import {LicenseInfo} from '@mui/x-license';

/**
 * This license is NOT a secret, so we allow it hardcoded
 * @see https://mui.com/x/introduction/licensing/#license-key
 */
export const configureMuiPro = () => {
  LicenseInfo.setLicenseKey(
    '51db0d5b3b8c41444193a844ddaf5d32Tz0xMTMxOTAsRT0xNzc5MzIxNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  );
};
